const ITEMS = [
    "RECYCLED HOCKEY STICKS",
    "SERRATED STEEL BLADE",
    "PRO SKATE LACE LOOP",
    "$40 — DM TO ORDER",
    "FLIP IT LIKE YOU MEAN IT",
    "GAME-USED. GRILL-READY.",
];

export default function Marquee() {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div
            data-testid="editorial-marquee"
            className="marquee-hover relative overflow-hidden border-y border-[#2A2A36] bg-[#0D0D11] py-5 sm:py-7"
        >
            <div className="animate-marquee flex w-max items-center">
                {[0, 1].map((half) => (
                    <div key={half} className="flex items-center">
                        {row.map((item, i) => (
                            <span key={`${half}-${i}`} className="flex items-center">
                                <span
                                    className={`font-cond px-6 text-2xl font-bold uppercase tracking-wide sm:px-10 sm:text-4xl ${
                                        i % 3 === 1 ? "text-outline" : "text-[#F2F2F7]"
                                    } ${item.includes("$40") ? "!text-[#FF3B30]" : ""}`}
                                >
                                    {item}
                                </span>
                                <span className="text-lg text-[#FF3B30] sm:text-2xl">✦</span>
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
